'use strict';

/**
 * @abstract
 */
bbw.model.PubPostsManager = bbw.model.BasePostsManager.extend({

    $inject: ['rpcClient', 'modelFactory', '$q', '$timeout'],

    order: undefined,

    topLimit: 50,

    _userId: null,

    _configurePostsModel: function() {
        this.order = {
            top: false
        };
        this._posts.configure({
            'type_name': this._getPostsType(),
            'limit': this.perPage,
            'order': 'desc'
        });
    },

    _getPostsType: function() {
        Class.abstractMethod();
    },

    setByUserId: function(userId) {
        this._userId = parseInt(userId);
        if (!(this._userId > 0)) {
            this._userId = null;
        }
        return this;
    },

    setTopOrder: function(isTopOrder) {
        this.order.top = !!isTopOrder;
        return this;
    },

    watchOrder: function(path, fn) {
        if (angular.isFunction(path)) {
            fn = path;
            path = undefined;
        }
        var watchExpr = this._scopePath + '.' + (path ? ('order.' + path) : 'order');
        this._scope.$watch(watchExpr, fn);
        return this;
    },

    _getLoadPostsArgs: function(limit) {
        var subtype, unmoderated;
        if (this.subtype === 'unmoderated') {
            this.order.top = false;
            unmoderated = true;
        } else {
            subtype = this.subtype || undefined;
        }
        return {
            'collection_identifier': subtype || undefined,
            'unmoderated': unmoderated,
            'author_user_id': this._userId || undefined,
            'top': this.order.top ? true : undefined,
            'limit': this.order.top ? this.topLimit : limit
        };
    },

    _initSubtypes: function() {
        Class.abstractMethod();
    }

});
